import { config } from "../../config.js";
import { get, post, put } from "../../services/httpAdmin.js";
import { format } from "date-fns";
import { formatInt } from "../../services/utilities.js";

export let products = async function () {
  return await get(`${config.apiUrl}/products`);
};

export let getProduct = async function (id) {
  if (id) {
    let data = await get(`${config.apiUrl}/admin/products/${id}`);
    if (data.sale_start !== null && data.sale_start !== "") {
      let localDate = new Date(data.sale_start);
      data.sale_start = format(localDate, "yyyy-MM-dd'T'HH:mm");
    }
    if (data.sale_end !== null && data.sale_end !== "") {
      let localDate = new Date(data.sale_end);
      data.sale_end = format(localDate, "yyyy-MM-dd'T'HH:mm");
    }
    return data;
  }
};

export let getAttrs = async function (typeId) {
  return get(`${config.apiUrl}/product_types/${typeId}/attr`);
};

export let createProduct = async function (product) {
  // convert prices back to int
  if (product.price && product.price > 0)
    product.price = formatInt(product.price);
  if (product.sale_price && product.sale_price > 0)
    product.sale_price = formatInt(product.sale_price);
  let url = `${config.apiUrl}/products`;
  let data = JSON.stringify(product);
  let result = await post(url, data);
  if (result.error) {
    throw result.error;
  }
  return result;
};

export let updateProduct = async function (product) {
  // convert prices back to int
  if (product.price && product.price > 0)
    product.price = formatInt(product.price);
  if (product.sale_price && product.sale_price > 0)
    product.sale_price = formatInt(product.sale_price);
  let data = JSON.stringify(product);
  let result = await put(
    `${config.apiUrl}/products/${product.id}`,
    data,
    "application/json",
    true
  );
  if (result.error) {
    throw result.error;
  }
  return result;
};

export let uploadImage = async function (image) {
  var formData = new FormData();
  formData.append("images", image);

  return await post(`${config.apiUrl}/image/upload`, formData, null);
};

export let bulkEdit = async function (
  productList,
  field,
  val,
  tags,
  categories
) {
  if (field === "price_int" || field === "sale_price_int") {
    val = formatInt(val);
    val = val.toString();
  }

  let body = JSON.stringify({
    product_ids: productList,
    field,
    value: val,
    tags,
    categories,
  });
  let url = `${config.apiUrl}/bulk/products`;
  let success = await put(url, body, "application/json", false);
  return success;
};

export let exportProducts = async function () {
  try {
    return await post(
      `${config.apiUrl}/export?type=products`,
      JSON.stringify({}),
      "text/csv",
      true
    );
  } catch (err) {
    return false;
  }
};

export let searchProductsForOrder = async function (query, order_type) {
  try {
    const ids = [];
    if (order_type === 'purchase') {
      ids.push(3); // accessories
      ids.push(2); // puzzle purchase
    } else {
      ids.push(1); // rental
    }

    let allResults = [];
    const baseUrl = `${config.apiUrl}/products?limit=15&query=${query}`;

    for (const product_type_id of ids) {
      const url = `${baseUrl}&product-type-id=${product_type_id}`;
      const results = await get(url, true);
      allResults = allResults.concat(results.products);
    }
    return allResults;

  } catch (err) {
    return [];
  }
};
